import Api from "utils/Api";

const GET_TOTAL_VENDOR_PRODUCTS_URL = `/product/total_vendor_product_list/`;
const GET_VENDOR_PRODUCTS_URL = `/product/vendor_product_list/`;
const GET_PRODUCTS_BRAND_URL = `/product/brand_product/`;
const GET_PRODUCTS_URL = `/product/product/`;
const GET_SIMILIAR_PRODUCTS_URL = `/product/similar_product/`;
const GET_SINGLE_PRODUCT_URL = (id) => `/product/vendor_product/${id}/`;

export const GetTotalVendorProducts = (category_slug, params) => {
  return Api.get(GET_TOTAL_VENDOR_PRODUCTS_URL, {
    params: { category_slug, ...params },
  });
};

export const GetVendorProducts = (params) => {
  return Api.get(GET_VENDOR_PRODUCTS_URL, { params });
};

export const GetProductsBrand = (params) => {
  return Api.get(GET_PRODUCTS_URL, {
    params: { ...params, product__channel: process.env.REACT_APP_CHANNEL_ID },
  });
};

export const GetProducts = (params) => {
  return Api.get(GET_PRODUCTS_URL, {
    params: { ...params, channel: process.env.REACT_APP_B2C_CHANNEL_ID },
  });
};

export const GetSingleProduct = (id) => {
  return Api.get(GET_SINGLE_PRODUCT_URL(id));
};

export const GetSimiliarProducts = (vendor_product_id) => {
  return Api.get(GET_SIMILIAR_PRODUCTS_URL, { params: { vendor_product_id } });
};
